import {useEffect} from "react";
import firebase from "firebase";
import axios from "axios";
import {playNextSong} from "./spotifyController";
import {addToState, getState} from "./stateController";
import useScript from "./useScript";


function SpotifyPlayer() {
	useScript("https://sdk.scdn.co/spotify-player.js")


	useEffect(() => {
		let nextSongTimer = 0
		let timerId;

		// init spotify sdk
		window.onSpotifyWebPlaybackSDKReady = () => {
			if(!global.player) {
				global.player = new window.Spotify.Player({
					name: 'Music by Vote',
					getOAuthToken: cb => {
						axios.post(global.API_URL + "/refresh-token", {
							"token": getState().apiToken
						}).catch(error => console.log(error));

						cb(getState().access_token)

					}
				});
			}


			// Error handling
			global.player.addListener('initialization_error', ({ message }) => { console.error(message); });
			global.player.addListener('authentication_error', ({ message }) => { console.error(message); });
			global.player.addListener('account_error', ({ message }) => { console.error(message); });
			global.player.addListener('playback_error', ({ message }) => { console.error(message); });

			// Playback status updates
			global.player.addListener('player_state_changed', state => {
				if(state !== null && state.isPlaying !== null) {
					// update room state
					const db = firebase.firestore();

					const artists = state.track_window.current_track.artists.map(artist => {
						return artist.name
					})

					db.collection("rooms").doc(getState().room_code).update({
						'now_playing.album_cover': state.track_window.current_track.album.images[1].url,
						'now_playing.artists': artists,
						'now_playing.is_playing': !state.paused,
						'now_playing.spotify_id': state.track_window.current_track.id,
						'now_playing.title': state.track_window.current_track.name,
					})
						.then(() => {})
						.catch((error) => {
							console.error("Error updating document: ", error);
						});

					// update next song time
					nextSongTimer = state.duration - state.position - 2000
					clearTimeout(timerId)
					if(!state.paused) {
						timerId = setTimeout(() => {
							if(getState().next_song !== undefined) {
								const nextSong = getState().next_song
								playNextSong(nextSong["uri"], nextSong["offset"])
							}
						}, nextSongTimer);
					}
				}

			});

			// Ready
			global.player.addListener('ready', ({ device_id }) => {
				addToState({device_id: device_id})
				axios.post(global.API_URL + "/initialize-player", {
					"token": getState().apiToken,
					"deviceId": device_id
				}).catch(error => console.log(error));
			});

			// Not Ready
			global.player.addListener('not_ready', ({ device_id }) => {
				console.log('Device ID has gone offline', device_id);
			});

			// Connect to the player!
			global.player.connect();

		};
	}, []);

	return(
		<div/>
	)
}

export default SpotifyPlayer
